import axiosInstance from "../instance/axiosInstance";

class OverviewApi {
  static async overview() {
    try {
      const response = await axiosInstance.get("/settings/overview");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  
}

export default OverviewApi;
